<template>
    <div class="vld-parent">
        <loading :active.sync="bool_fullLoading" :is-full-page="bool_fullScreen"></loading>
        <div v-if="bool_isAMV">
            <transition name="modal-fade">
                <div class="modal-backdrop" margin="auto">
                    <div style="width:65%">
                        <CCard>
                            <CCardBody class="modal-body">
                                <CRow>
                                    <CCol col="8">
                                        <h4 id="traffic" class="card-title mb-0">{{this.getLanguage["CMS"]["S"]}}</h4>
                                    </CCol>
                                    <CCol col="4">

                                        <CButton id="btn-close1" class="float-right"
                                                 @click="closeAdd()">

                                            <CIcon name=cilX></CIcon>

                                        </CButton>
                                    </CCol>
                                </CRow>
                                <div class='subHeaderHR'></div>
                                <CRow>
                                    <CCol col="6" class="form-group">
                                        <label class="col-form-label-sm">{{this.getLanguage["DM"]["AGI"]}}<span class="required" /> :</label>
                                        <customtreeselect :multiple="false"
                                                    :options="dd_agentgroup"
                                                    :flat="true"
                                                    :defaultExpandLevel="Infinity"
                                                    :clearable="false"
                                                    :disabled="isEdit"
                                                    :placeholder="this.utilGetDDLanguage('GL.AGT')"
                                                    v-model="obj_T5GP.AGIT"
                                                    @input="AgentGroupChange"
                                                    ref="AGIT" />
                                        <span class="ErrMsg">{{ ValidationErrMsg('AGIT') }}</span>
                                    </CCol>
                                    <CCol col="6">
                                        <label class="col-form-label-sm">{{this.getLanguage["CMS"]["DN"]}}<span class="required" /> :</label>
                                        <treeselect :multiple="false"
                                                    :options="dd_do"
                                                    :placeholder="this.utilGetDDLanguage('CMS.DN')"
                                                    :noOptionsText="this.getLanguage['GL']['NOA']"
                                                    
                                                    v-model="obj_T5GP['DI']"
                                                    :disabled="isEdit"
                                                    @input="DomainChange"
                                                    ref="DI" />
                                        <span class="ErrMsg">{{ ValidationErrMsg('DI') }}</span>
                                    </CCol>
                                </CRow>
                                <CRow>
                                    <CCol>
                                        <div class="custom-table-wrapper">
                                            <table class='custom-table afb-blue'>
                                                <thead>
                                                    <tr>
                                                        <th>{{this.getLanguage["CMS"]["GC"]}}<span class="required" /> </th>
                                                        <th>{{this.getLanguage["CMS"]["G"]}}<span class="required" /> </th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                <td>
                                                    <div style="display:flex">
                                                        <div class="holdTree">
                                                            <treeselect style="max-width:200px; padding-top:3px;"
                                                                        :multiple="false"
                                                                        :load-options="loadCategoryOptions"
                                                                        :placeholder="this.utilGetDDLanguage('CMS.GC')"
                                                                        :options="ddCategoryList"
                                                                        :clearable="false"
                                                                        :disabled="isEdit"
                                                                        :auto-load-root-options="true"
                                                                        v-model="obj_T5GP.GCI"
                                                                        @input="ClearDD"
                                                                        ref="GCI" />
                                                            <span class="ErrMsg">{{ ValidationErrMsg('GCI') }}</span>
                                                        </div>
                                                    </div>
                                                </td>

                                                <td>
                                                    <div v-for="(num,index) in 5" v-bind:key="index">
                                                        <div style="display:flex;justify-content: space-between;align-items: center;margin-bottom: 5px;">
                                                            <div class="holdNo">{{index+1}}</div>
                                                            <div style="margin-right: auto;">
                                                                <treeselect style="max-width:300px"
                                                                            :load-options="loadProviderOptions"                                                                                                                                                   
                                                                            :options="ddProviderList"
                                                                            :noOptionsText="getLanguage['GL']['NOA']"
                                                                            placeholder                                                                        
                                                                            @input="setGameDD($event,index)"
                                                                            :auto-load-root-options="isEdit"                                                                       
                                                                            v-model="obj_T5GP.GPIT[index]"
                                                                            ref="GIT.$each" />
                                                            </div>

                                                            <treeselect style="max-width:200px"
                                                                        :options="ddGameList[index]"
                                                                        placeholder
                                                                        v-model="obj_T5GP.GIT[index]" />

                                                            <!--  @input="whenGameAuto($event,index)" /> -->


                                                            <CButton color="outline-info" size="sm" @click="changeAuto(index)">{{getLanguage["T5"]["CTA"]}}</CButton>
                                                        </div>
                                                    </div>
                                                    <span class="ErrMsg">{{ ValidationErrMsg('GIT') }}</span>
                                                </td>


                                                </tbody>
                                            </table>
                                        </div>
                                    </CCol>
                                </CRow>


                                <div style="text-align:center;margin-top:20px">
                                    <CButton color="outline-info" size="sm" @click="saveT5()">
                                        <span class='plusIcon cil-plus'></span>
                                        {{this.getLanguage["BTN"]["SV"]}}
                                    </CButton>
                                </div>
                                <label class="mandatory_Field">{{this.getLanguage['MANDATORY']['FIELDS']}}</label>


                            </CCardBody>
                        </CCard>
                    </div>
                </div>
            </transition>
        </div>

        <div class="container-fluid">
            <CRow>
                <CCol>
                    <div class='pageHeader position-relative'>
                        <h2 id="titleHeight">{{getLanguage["CMS"]["GR"]}}</h2>
                        <CButton size="sm" color="outline-info" @click="addT5()" v-if="checkModuleAccess2(constAccessType.add)"> <span class='plusIcon cil-plus'></span> {{getLanguage["BTN"]["AN"]}}</CButton>

                        <div class="custom-tooltip position-absolute" style="right: 0; border: 0.5rem;" @click="bool_showSearchBar ? bool_showSearchBar = false:bool_showSearchBar = true">
                            <img src="../../../assets/icons/file-search.svg" width="23" />
                            <span class="custom-tooltiptext" style=" left: auto;right:0%; bottom: -130%;" v-if="bool_showSearchBar">{{getLanguage["BTN"]["CSB"]}}</span>
                            <span class="custom-tooltiptext" style=" left: auto;right:0%; bottom: -130%;" v-else>{{getLanguage["BTN"]["SSB"]}}</span>
                        </div>
                    </div>
                    <div class="searchForm" v-show="bool_showSearchBar">
                        <div class='searchBox'>
                            <div class='searchCol'>
                                <label class="searchLabel"> {{this.getLanguage['DM']['AGI']}}:</label>
                                <customtreeselect :multiple="false"
                                            :options="dd_agentgroupfs"
                                            :flat="true"
                                            :defaultExpandLevel="Infinity"
                                            :placeholder="this.getLanguage['DM']['AGI']"
                                            @input="AgentGroupChangefs"
                                            v-model="str_fv_holdAG" />
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage["SEO"]["DN"]}} :</span>
                                <treeselect :multiple="false"
                                            :options="dd_dofs"
                                            :placeholder="this.utilGetDDLanguage('SEO.DN')"
                                            :noOptionsText="this.getLanguage['GL']['NOA']"
                                            v-model="str_FV[1].FV" />
                            </div>
                        </div>
                        <div class='searchBtnCol'>
                            <CButton v-shortkey="['enter']" @shortkey="newSearch()" class='searchBtn' ref="search" size="sm" block color="success" @click=" newSearch()"><span class='searchIcon cil-search'></span><span>{{getLanguage["BTN"]["SR"]}}</span></CButton>
                        </div>
                    </div>
                </CCol>
            </CRow>

            <div class='table-wrapper'>
                <header class="table-header">
                    <strong>{{this.getLanguage["CMS"]["GRL"]}}</strong>
                    <div class="pageBtn">
                        <button @click="ctrPage(+int_Page - 1)">
                            <span class="arrowLeft"></span>
                        </button>
                        <input class="page-control"
                               v-model="int_Page"
                               type="number"
                               v-shortkey.avoid
                               @keyup="ctrPage(+int_Page,0)" />
                        <span class="tableItemCount">/ {{int_TP}}</span>
                        <button @click="ctrPage(+int_Page + 1)">
                            <span class="arrowRight"></span>
                        </button>
                    </div>
                </header>

                <div class="custom-table-wrapper" id="tHead">
                    <table class='custom-table afb-blue'>
                        <thead>
                            <tr>
                                <th>{{this.getLanguage["CMS"]["BN"]}}<i @click="setSortTable('AGN')" :class="setSortLogo('AGN')"  class="sortlogo"></i></th>
                                <th>{{this.getLanguage["CMS"]["DN"]}}</th>
                                <th v-if="checkModuleAccess2(constAccessType.edit)">{{getLanguage["GL"]["ACT"]}}</th>
                                <th>{{this.getLanguage["CMS"]["GT"]}}</th>
                                <th>{{this.getLanguage["CMS"]["R"]}}</th>
                                <th>{{this.getLanguage["CMS"]["G"]}}</th>
                            </tr>
                        </thead>
                    </table>
                </div>
                <div class="custom-table-wrapper" id="tBody">
                    <table class='custom-table afb-blue'>
                        <thead>
                            <tr>
                                <th>{{this.getLanguage["CMS"]["BN"]}}<i @click="setSortTable('AGN')" :class="setSortLogo('AGN')" class="sortlogo"></i></th>
                                <th>{{this.getLanguage["CMS"]["DN"]}}</th>
                                <th v-if="checkModuleAccess2(constAccessType.edit)">{{getLanguage["GL"]["ACT"]}}</th>
                                <th>{{this.getLanguage["CMS"]["GT"]}}</th>
                                <th>{{this.getLanguage["CMS"]["R"]}}</th>
                                <th>{{this.getLanguage["CMS"]["G"]}}</th>
                            </tr>
                        </thead>
                        <tbody>
                        <td colspan="100%" v-if=" arry_t5l.length == 0">{{this.getLanguage['GL']['NR']}}</td>
                        <tr v-for="(data,index) in arry_t5l" v-bind:key="index">
                            <td><span v-if="valitadeGN(index)">{{data.AGN}} ({{data.PC}})</span></td>
                            <td>
                                <span v-if="valitadeDN(index) && ((isSENS == 1 && data.AGI == curAGI) || isSENS == 0)">{{data.DN}}</span>
                                <span v-else-if="valitadeDN(index) && (isSENS == 1 && data.AGI != curAGI)">{{data.DN}}(XX)</span>
                            </td>
                            <td v-if="checkModuleAccess2(constAccessType.edit)">
                                <span v-if="valitadeGT(index)" id="actionBtnCol">
                                    <div v-if="((isSENS == 1 && data.AGI == curAGI) || isSENS == 0)" class="custom-tooltip">
                                        <i class="cil-color-border" @click='editT5(data.DI,data.GCI)'></i>
                                        <span class="custom-tooltiptext">{{getLanguage["BTN"]["ED"]}}</span>
                                    </div>
                                    <div v-else-if="(isSENS == 1 && data.AGI != curAGI)" class="custom-tooltip">
                                        <i class="cil-color-border"></i>
                                        <span class="custom-tooltiptext">{{getLanguage["BTN"]["ED"]}}</span>
                                    </div>
                                </span>
                            </td>
                            <td><span v-if="valitadeGT(index)"><span v-if="data.GCI !== 0">{{renderCategory(data.GCI)}}</span><span v-if="data.GCI == 0">{{getLanguage["GL"]["ALL2"]}}</span></span></td>
                            <td>{{data.R}}</td>
                            <td>
                                <span v-if="data.GI !== 0">{{ renderGameName(data.DPN, data.GN) }} ({{ renderProviderName(data.DPN) }})</span>
                                <span v-else-if="data.GI == 0 && data.GPI !== 0" style="color:green;">{{getLanguage["T5"]["AUG"]}} ({{data.PN}})</span>
                                <span v-else-if="data.GI == 0" style="color:green;">{{getLanguage["T5"]["AUG"]}}</span>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    //import '@riophae/vue-treeselect/dist/vue-treeselect.css'
    import Treeselect from '@riophae/vue-treeselect'
    import { customtreeselect } from '@/views/CustomControl/index.js'
    import DateRangePicker from 'vue2-daterange-picker'
    //you need to import the CSS manually (in case you want to override it)
    import Loading from 'vue-loading-overlay';
    import { mapGetters, mapActions } from 'vuex'
    import { required, minLength, between, url } from 'vuelidate/lib/validators'
    import { constAccessType, loadingFullScreen } from '@/modules/Constant.js';
    import genericHelper from "@/modules/GenericHelper.js";
    import moment from "moment";
    import Vue from 'vue'
    import $ from 'jquery'
    //Vue.use(require('vue-shortkey'))

    export default {
        mixins: [genericHelper],
        components: {
            Treeselect,
            customtreeselect,
            Loading
        },
        props: {

        },
        data() {
            return {
                bool_isAMV: false, // Add Modal Visible
                int_lblPage: 1,
                bool_fullLoading: false,
                bool_fullScreen: loadingFullScreen, //Full Screen
                bool_showSearchBar: true,
                timeout: null,
                //the parameter of getList()
                int_Page: 1,//current Pagr
                int_IC: 1, // Item Count
                int_RC: 100, //Row Count
                str_tableSortBy: "", //(sort the table col name)
                bool_isSort: false, // Table Ascending Descending
                str_FV: [{ F: "agi" }, { F: "di" }], //Filter Value
                //ctrl Page valuev (A return Data )
                int_TI: 0,//Total Items
                int_TP: 1, //Total Page
                //array hold data
                isEdit: true,
                bool_SkipLoad: false,
                ddCategoryList: null,
                ddProviderList: null,
                ddProviderListFull: null,
                ddGameList: [],
                // selectedFile: null,
                dd_agentgroup: [],
                dd_agentgroupfs: [],
                dd_dofs: [], // Domain Option for search
                dd_do: [], // Domain Option
                str_fv_holdAG: null,
                bool_CV: false, // Check Validation
                arry_t5l: [], //Bank List
                obj_T5GP: [], //Add Bank
                constAccessType: constAccessType
            }
        },
        validations: {
            obj_T5GP: {
                AGIT: { required },
                AGIT: { required },
                DI: { required },
                GCI: { required },
                GIT: { required, minLength: minLength(5), $each: { required } }

            }
        },
        computed: {
            ...mapGetters('Language', ['getLanguage']),
            ...mapGetters('UserInfo', ['checkModuleAccess', 'getUserInfo']),
        },
        methods: {
            closeAdd() {
                this.bool_isAMV = !this.bool_isAMV;
                this.bool_CV = false;
            },
            checkModuleAccess2(type) {
                return this.checkModuleAccess('T5G', 'GS', type);
            },
            CountItem(value) {
                if (this.int_IC != 1) {
                    return value + ((this.int_IC - 1) * this.int_RC);
                }
                else {
                    return value;
                }
            },
            checkStatus(RS) {
                var a = this.$parent.checkStatus(RS);
            },
            ctrPage(newPage,inputValue = 1) {
                if (inputValue == 0) {
                    this.int_Page = Math.max(1, Math.min(newPage, this.int_TP));
                }
                else {
                    this.int_Page = (newPage > this.int_TP) ? 1 : (newPage < 1) ? this.int_TP : newPage;
                }
                this.int_IC = this.int_Page;
                this.getT5kList();
            },
            newSearch() {
                if (!this.bool_isAMV) {
                    this.$refs.search.focus();
                    this.int_Page = 1;
                    this.int_IC = 1;
                    this.getT5kList();
                }
            },

            ClearDD(value) { //here clear option and select
                this.ddProviderList = null;
                for (var i = 0; i <= 4; i++) {
                    this.obj_T5GP.GPIT[i] = null;
                    this.obj_T5GP.GIT[i] = null;
                    this.ddGameList[i] = [{ id: "0", label: this.getLanguage["T5"]["AUG"] }]
                }
            },
            AgentGroupChangefs(value) {

                if (value != undefined) {
                    var that = this;
                    var agi = 0;

                    if (value != "") {
                        agi = value.split("-")[1];
                    }
                    this.getDataApi(`/api/dd/dn/` + agi,
                        function (d, s) {
                            if (s) {
                                that.dd_dofs = d.dropdownlist
                            }
                        });
                }

            },
            AgentGroupChange(value) {
                if (this.obj_T5GP['I'] == 0) {
                    this.obj_T5GP['DI'] = null;
                }

                var agi = 0;

                if (value != "") {
                    agi = value.split("-")[1];
                }

                this.getDomainDropDown(agi)
                this.ClearDD(1);
            },
            DomainChange(value) {
                this.ClearDD(1);
            },
            getDomainDropDown(agi) {
                var that = this;
                this.getDataApi(`/api/dd/dn/` + agi,
                    function (d, s) {
                        if (s) {
                            that.dd_do = d.dropdownlist;
                        }
                    });

            },
            returnAGI() {
                if (this.obj_T5GP.AGIT != "") {
                    var agi = this.obj_T5GP.AGIT.split("-");
                    agi = agi[1];
                    return agi;
                }
                else {
                    return null;
                }
            },
            getDropdownList() {
                var that = this;
                this.getDataApi(`/api/dd/ag/1/0`,
                    function (d, s) {
                        if (s) {

                            that.dd_agentgroupfs = that.deepClone(d.dropdownlist);

                            if (that.dd_agentgroupfs.length > 0) {
                                that.dd_agentgroupfs.forEach(that.disableAgentGroupParent);
                            }

                            that.dd_agentgroup = that.deepClone(d.dropdownlist);

                            if (that.getUserInfo.ISENS == 1) {
                                that.dd_agentgroup = that.dd_agentgroup.filter(f => f.id == "3-" + that.getUserInfo.AGI);
                            }

                            if (that.dd_agentgroup.length > 0) {
                                that.dd_agentgroup.forEach(that.disableAgentGroupParent);
                            }
                        }
                    });

                this.getProviderList();
            },
            disableAgentGroupParent(item, index) {
                var agi = item.id.split("-");
                if (agi[0] != "3") {
                    item.isDisabled = true;
                }

                if (item.children && item.children.length > 0) {
                    item.children.forEach(this.disableAgentGroupParent);
                }
            },
            loadCategoryOptions({ action, callback, instanceId }) {
                var that = this;
                this.getDataApi(`/api/dd/gameCat`,
                    function (d, s) {
                        if (s && d && d.dropdownlist) {
                            for (var i = 0; i < d.dropdownlist.length; i++) {
                                d.dropdownlist[i].label = that.renderCategory(d.dropdownlist[i].id);
                            }
                            that.ddCategoryList = d.dropdownlist;
                            that.setddCategoryList();
                            //that.ddCategoryList.push({ id: "0", label: "All" });
                            //that.ddCategoryList=[{ id: "0", label: "All" }]
                        }
                        else {
                            that.ddCategoryList = null;
                        }

                        callback();
                    });
            },
            renderCategory(id) {
                return this.getLanguage["GC"][id];
            },
            setddCategoryList() {
                this.ddCategoryList.push({ id: "0", label: this.getLanguage['GL']['ALL2'] });
            },
            loadProviderOptions({ action, callback, instanceId }) {
                var that = this;
                if (this.obj_T5GP.AGIT == null || this.obj_T5GP.AGIT == undefined || this.obj_T5GP.GCI == null || this.obj_T5GP.GCI == undefined) {
                    callback(this.getLanguage['T5']['PSBC']);
                } else {
                    var domainId = this.obj_T5GP.DI == null ? 0 : this.obj_T5GP.DI;
                    this.getDataApi(`/api/dd/gameP/${this.returnAGI()}/${domainId}/${this.obj_T5GP.GCI}`,
                        function (d, s) {
                            if (s && d && d.dropdownlist) {
                                that.ddProviderList = d.dropdownlist;
                                for (var i = 0; i < that.ddProviderList.length; i++) {
                                    that.ddProviderList[i].label = that.renderProviderName(that.ddProviderList[i].label2);
                                }
                                that.ddProviderList.push({ id: "0", label: "Automatic generated" });
                            }
                            else {
                                that.ddProviderList = null;
                            }

                            callback();
                        });
                }
            },
            getProviderList() {
                var that = this;
                this.getDataApi(`/api/dd/gameP/0/0/0`,
                    function (d, s) {
                        if (s && d && d.dropdownlist) {
                            that.ddProviderListFull = d.dropdownlist;
                            for (var i = 0; i < that.ddProviderListFull.length; i++) {
                                that.ddProviderListFull[i].label = that.renderProviderName(that.ddProviderListFull[i].label2);
                            }
                        }
                        else {
                            that.ddProviderList = null;
                        }
                    });
            },
            setGameDD(value, index) {
                if (this.obj_T5GP.GPIT[index] != 0 && this.bool_SkipLoad == false) {
                    this.obj_T5GP.GIT[index] = null;
                    this.$forceUpdate();
                }
                if (this.isEdit == false && this.obj_T5GP.GIT[index] != 0) {
                    this.ddGameList[index] = null;

                } else if (this.isEdit == true) {

                    this.getGameDropDown(index, value == 0 ? true : false);
                }

                if (value && this.isEdit == false) {
                    this.getGameDropDown(index, value == 0 ? true : false);
                }
            },
            whenGameAuto(value, index) {
                if (value == 0 && this.obj_T5GP.GPIT[index] != 0) {
                    this.obj_T5GP.GPIT[index] = 0;
                }

            },
            getGameDropDown(index, isAuto = false) {
                var that = this;
                if (that.obj_T5GP.GPIT[index] > 0) {
                    var providerName = that.ddProviderListFull.find(o => o.id == that.obj_T5GP.GPIT[index]);


                    this.getDataApi(`/api/dd/gamer/${this.returnAGI()}/${that.obj_T5GP.GCI}/${that.obj_T5GP.GPIT[index]}`,
                        function (d, s) {
                            if (s) {
                                that.ddGameList[index] = d.dropdownlist;
                                for (var idx = 0; idx < that.ddGameList[index].length; idx++) {
                                    // that.ddGameList[index][idx].label = that.changeGameName(that.ddGameList[index][idx].label, providerName);
                                    that.ddGameList[index][idx].label = that.changeGameName(that.ddGameList[index][idx].extra, that.ddGameList[index][idx].label);
                                }
                                that.ddGameList[index].push({ id: "0", label: that.getLanguage["T5"]["AUG"] });
                                // that.ddCategoryList=[{ id: "0", label: "All" }]
                                that.$forceUpdate();
                            }
                            else {
                                that.ddGameList[index] = null;
                                that.$forceUpdate();
                            }
                        });
                }
                if (isAuto == true) {
                    this.ddGameList[index] = [{ id: "0", label: this.getLanguage["T5"]["AUG"] }]
                    this.obj_T5GP.GIT[index] = 0;
                    this.$forceUpdate();
                }
            },
            // changeGameName(item, providerName) {
            //     if (providerName && providerName.label)
            //         return this.getLanguage[providerName.label][item];

            //     return item;
            // },
            changeGameName(provider, item) {
                if (provider in this.getLanguage && item in this.getLanguage[provider])
                    item = this.getLanguage[provider][item];

                return item;
            },
            getT5kList() {
                this.bool_fullLoading = true;
                var that = this;
                var path = this.getListingParamQuery(this.int_Page, this.int_RC, this.str_tableSortBy, this.bool_isSort);

                if (this.str_fv_holdAG != null) {
                    var agi = this.str_fv_holdAG.split("-");
                    this.str_FV[0].FV = agi[1];
                } else {
                    this.str_FV[0].FV = null;
                }

                for (var i = 0; i < this.str_FV.length; i++) {
                    if (this.str_FV[i].FV) {
                        if (path) {
                            path += "&";
                        }
                        path += ("f[" + this.str_FV[i].F + "]=" + this.str_FV[i].FV);
                    }
                };

                this.getDataApi(`/api/t5g/l?${path}`,
                    function (d, s) {
                        that.bool_fullLoading = false;
                        if (s) {
                            that.setT5kList(d.D);
                            that.resizeTableHead();
                        }
                    });
            },
            setT5kList(data) {   // this out put at Bank.js and this output after get list
                this.arry_t5l = data.Items;
                this.int_TP = Math.max(data.TotalPages, 1);                
                this.int_TI = data.TotalItems;
            },

            addT5() {
                this.obj_T5GP = {
                    I: 0,
                    RS: 2,
                    CTS: "0001-01-01T00:00:00",
                    CBI: 0,
                    CB: null,
                    UTS: "0001-01-01T00:00:00",
                    UBI: 0,
                    UB: null,
                    AGI: null,
                    AGIT: null,
                    DI: null,
                    GCI: null,
                    GPIT: [],
                    GIT: [],
                    R: ""
                };
                this.bool_CV = false;
                this.isEdit = false;
                this.bool_isAMV = true;
                this.ddProviderList = [];
                for (var i = 0; i < 4; i++) {
                    this.ddGameList[i] = [{ id: "0", label: this.getLanguage["T5"]["AUG"] }];
                }

                if (this.dd_agentgroup[0].children == undefined) {
                    var at = 0;
                    at = this.dd_agentgroup[0].id.split("-")[0];
                    if (at == 3 && this.dd_agentgroup.length < 2) {
                        this.obj_T5GP.AGIT = this.dd_agentgroup[0].id;
                        this.AgentGroupChange(this.obj_T5GP.AGIT);
                    }
                }

            },
            ValidationErrMsg(value) {
                switch (value) {
                    case 'AGIT':
                        if (!this.$v.obj_T5GP.AGIT.required && this.bool_CV) {
                            return String.format(this.utilGetErrorLanguage("ERR.1001"), this.utilGetErrorLanguage("AMT.AGI"));
                        }
                        break;
                    case 'DI':
                        if (!this.$v.obj_T5GP.DI.required && this.bool_CV) {
                            return String.format(this.utilGetErrorLanguage("ERR.1001"), this.utilGetErrorLanguage("CMS.DN"));
                        }
                        break;
                    case 'GCI':
                        if (!this.$v.obj_T5GP.GCI.required && this.bool_CV) {
                            return String.format(this.utilGetErrorLanguage("ERR.1001"), this.utilGetErrorLanguage("AMT.GCI"));
                        }
                        break;
                    case 'GIT':
                        if (!this.$v.obj_T5GP.GIT.required && this.bool_CV) {
                            return String.format(this.utilGetErrorLanguage("ERR.1001"), this.utilGetErrorLanguage("CMS.G"));
                        }
                        break;
                }
            },
            editT5(di, gametype) {
                this.bool_fullLoading = true;
                this.isEdit = true;
                this.bool_SkipLoad = true;
                var that = this;
                this.getDataApi(`/api/t5g/g/${gametype}/${di}`,
                    function (d, s) {
                        that.bool_fullLoading = false;
                        if (s) {
                            that.obj_T5GP = {
                                I: 0,
                                RS: 2,
                                CTS: "0001-01-01T00:00:00",
                                CBI: 0,
                                CB: null,
                                UTS: "0001-01-01T00:00:00",
                                UBI: 0,
                                UB: null,
                                DI: d.D[1].DI,
                                AGI: d.D[1].AGI,
                                GCI: d.D[1].GCI,
                                GPIT: [],
                                GIT: [],
                                R: ""
                            };


                            if (that.obj_T5GP.AGI != 0) {
                                that.obj_T5GP.AGIT = "3-" + that.obj_T5GP.AGI;
                            }
                            that.ClearDD(1);
                            for (var i = 0; i < d.D.length; i++) {
                                that.obj_T5GP.GPIT[i] = d.D[i].GPI;
                                that.obj_T5GP.GIT[i] = d.D[i].GI;
                                that.setGameDD(that.obj_T5GP.GPIT[i], i)
                            }
                            that.getDomainDropDown(that.obj_T5GP.AGI);
                            that.bool_isAMV = true;
                            that.bool_SkipLoad = false;

                        }

                    });

            },


            saveT5() {
                this.bool_CV = true;
                this.$v.obj_T5GP.$touch();
                if (!this.$v.obj_T5GP.$error) {
                    this.bool_fullLoading = true;
                    this.bool_fullScreen = true;


                    if (this.obj_T5GP.AGIT != "") {
                        var agi = this.obj_T5GP.AGIT.split("-");
                        this.obj_T5GP.AGI = agi[1];
                    }


                    var that = this;

                    //if user edit, but want to retain image
                    this.postDataApi(`/api/t5g/s`, this.obj_T5GP,
                        function (d, s) {
                            that.bool_fullLoading = false;
                            that.bool_fullScreen = false;
                            if (s) {
                                that.bool_isAMV = false;
                                that.getT5kList();
                            }
                        });


                } else {
                    //get the object for validating.
                    const validation = this.$v["obj_T5GP"];
                    if (!validation) {
                        return;
                    }

                    function predicateRef(refIndex, getProp) {
                        if (refIndex.name.includes("$each")) {
                            const nameParts = refIndex.name.split(".");
                            for (let i = 0; i < refIndex.component.length; i++) {
                                const namePath = `${nameParts[0]}.$each.${i}`;
                                const validationProp = getProp(validation, namePath);
                                if (!validationProp || !validationProp.$error) {
                                    continue;
                                }

                                return refIndex.component[i];
                            }
                        } else {
                            const validationProp = getProp(validation, refIndex.name);
                            if (!validationProp || !validationProp.$error) {
                                return;
                            }

                            return refIndex.component;
                        }
                    }

                    const input = this.findRequiredInput(validation, this.$refs, predicateRef);
                    if (!input || typeof input.focus !== "function") {
                        return;
                    }

                    input.focus();
                }
            },
            removeBank(aRow) { //remove
                this.$fire({
                    title: this.getLanguage["GL"]["DLTM"],
                    width: '30em',
                    showCancelButton: true,
                    confirmButtonText: this.getLanguage["GL"]["YES"],
                    cancelButtonText: this.getLanguage["CNO"]["NO"],
                    reverseButtons: true,
                    customClass: {
                        title: 'afb-alert-title',
                        content: 'afb-alert-content',
                        actions: 'afb-alert-action'
                    }
                }).then((result) => {
                    if (result.value == true) {
                        this.bool_fullLoading = true;
                        var that = this;
                        var obj = {
                            i: aRow.I,
                            uts: aRow.UTS
                        };

                        this.postDataApi(`/api/t5gp/d`, obj,
                            function (d, s) {
                                that.bool_fullLoading = false;
                                if (s) {
                                    that.getT5kList();
                                    that.showSuccessMessage(that.utilGetErrorLanguage("ERR.SS"), that.utilGetErrorLanguage("GL.AS"));
                                }
                            });
                    }
                });
            },
            valitadeGT(index) {
                if (index == 0) {
                    return true;
                } else {
                    if (this.arry_t5l[index].CN != this.arry_t5l[index - 1].CN) {
                        return true;
                    } else if (this.arry_t5l[index].DI != this.arry_t5l[index - 1].DI) {
                        return true;
                    } else {
                        return false;
                    }
                }
            },
            valitadeGN(index) {
                if (index == 0) {
                    return true;
                } else {
                    if (this.arry_t5l[index].AGN != this.arry_t5l[index - 1].AGN) {
                        return true;
                    } else {
                        return false;
                    }
                }
            },
            valitadeDN(index) {
                if (index == 0) {
                    return true;
                } else {
                    if (this.arry_t5l[index].DN != this.arry_t5l[index - 1].DN) {
                        return true;
                    } else {
                        return false;
                    }
                }
            },
            changeAuto(index) {
                this.obj_T5GP.GPIT[index] = 0
                this.obj_T5GP.GIT[index] = 0
                this.$forceUpdate();
            },
            updateValue(value) {
                value = value;
            },
            renderGameName(providerName, gameName) {
                if (providerName in this.getLanguage && gameName in this.getLanguage[providerName])
                    return this.getLanguage[providerName][gameName];

                return gameName;
            },
            setSortTable(SV) { //SV = Sort Value
                this.int_Page = 1;
                this.int_IC = 1;
                this.str_tableSortBy = SV;
                this.bool_isSort = !this.bool_isSort;//change Ascending or Descending ,and then goto the {watch:/bool_isSort}
                this.getT5kList();
            },
            setSortLogo(str_TF) {
                return `cil-${this.str_tableSortBy == str_TF ? (this.bool_isSort ? 'sort-descending' : 'sort-ascending') : 'list'}`;//here change the sort logo
            },
            resizeTableHead() {
                this.initTableObserver();
                // Set up scroll synchronization
                const header = this.$el.querySelector("#tHead");
                const body = this.$el.querySelector("#tBody");

                header.addEventListener("scroll", () => {
                    body.scrollLeft = header.scrollLeft;
                });

                body.addEventListener("scroll", () => {
                    header.scrollLeft = body.scrollLeft;
                });
            },
            calculateWidths() {
                $('#tHead, #tBody').scrollLeft(0);
                const tables = this.$el.querySelectorAll('#tBody .custom-table');
                const headerCells = this.$el.querySelectorAll('#tHead .custom-table thead tr:nth-child(1) th');

                if (!headerCells.length) return;

                tables.forEach((table) => {
                    const bodyCells = table.querySelectorAll('tbody tr:first-child td');
                    if (!bodyCells.length) return;

                    // Reset all widths
                    [...headerCells, ...table.querySelectorAll('tbody tr td')].forEach(cell => cell.style.width = '');

                    // Apply new widths
                    bodyCells.forEach((cell, index) => {
                        const width = `${cell.getBoundingClientRect().width}px`;
                        if (headerCells[index]) headerCells[index].style.width = width;
                        table.querySelectorAll(`tbody tr td:nth-child(${index + 1}):not(td table td)`).forEach(td => td.style.width = width);
                    });
                });
            },
            initTableObserver() {
                const bodyTable = this.$el.querySelector('#tBody');

                // Observe changes in the body table
                const observer = new MutationObserver(() => {
                    this.calculateWidths(); // Recalculate widths when rows change
                });

                observer.observe(bodyTable, { childList: true, subtree: true });
                this.calculateWidths();
            },

        },
        watch: {
            bool_isAMV() {
                if (!this.bool_isAMV && this.bool_CV) {
                    this.showSuccessMessage(this.utilGetErrorLanguage("ERR.SS"), this.utilGetErrorLanguage("GL.AS"));
                }
            },
            getLanguage() {
                this.getT5kList();
            },
        },
        created() {
            this.$parent.showSubMenu = 'GS';
            this.$parent.showActiveMenu = 'GS.T5G';
            this.getT5kList();
            this.getDropdownList();
            this.isSENS = this.getUserInfo.ISENS;
            this.curAGI = this.getUserInfo.AGI;
        },
    }

</script>
<style>
    .holdNo {
        margin-top: 5px;
        margin-right: 5px;
    }

    .holdTree {
        width: calc(100% - 15px);
        margin-bottom: 10px;
    }
</style>



// WEBPACK FOOTER //
// src/components/SideMenu/GameSettings/Top5Game.vue